import React, { Component, Fragment, createRef } from "react";
import "component/listItem/CategoryType3/styles.scss";
import { ReactComponent as TrophyIcon } from "assets/icons/Tournament.svg";
import { ReactComponent as RibbonIcon } from "assets/icons/FreeRounds.svg";
import { ReactComponent as CrownIcon } from "assets/icons/Jackpot.svg";
import { ReactComponent as EditorsChoiceIcon } from "assets/icons/editors-badge.svg";
import bannerDefault from "assets/images/iconDefault.png";
import Highlighter from "react-highlight-words";
import { setDefaultImageFormat } from "utils/image";
import { getTotalPool } from "utils/getTotalpool";

/**
 * game icon with game title, provider and game type on the left
 */

class CategoryType3 extends Component {
  constructor(props) {
    super(props);
    this.onMouseOverHandler = this._onMouseOverHandler.bind(this);
    this.getTotalPool = getTotalPool.bind(this);
    this.mainComponent = createRef();
    this.iconDefaultRef = createRef();
    this.state = {
      hovered: false,
      isVisible: false,
      jackpotPool: null,
    };
  }

  _onMouseOverHandler(bol) {
    this.setState({
      hovered: bol,
    });
  }

  componentDidMount() {
    this.initObserver();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.latestBroadcast &&
      nextProps.latestBroadcast.get("jackpotGroupId") ===
        this.props.game.get("jackpotGroupId")
    ) {
      let latestJackpotPool;
      latestJackpotPool = {
        type: nextProps.latestBroadcast.get("type"),
        amount: nextProps.latestBroadcast.get("amount"),
      };
      this.setState({
        jackpotPool: {
          ...this.state.jackpotPool,
          [latestJackpotPool.type]: { amount: latestJackpotPool.amount },
        },
      });
    } else {
      this.setState({ jackpotPool: null });
    }
  }

  initObserver() {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.mainComponent.current) {
                this.setState({
                  isVisible: true,
                });
              }
            } else {
              if (this.mainComponent.current) {
                //clearInterval(this.initLoadDelay)
              }
            }
          });
        },
        {
          //rootMargin: '500px 0px 500px 0px'
          rootMargin: "0px 0px 0px 0px",
        }
      );
      observer.observe(this.mainComponent.current);
    } else {
      //this.getGames(this.props.link);
      //this.getTournamentPreview(this.props.links)
    }
  }

  render() {
    let { game, filter } = this.props;

    let searchArr;

    if (filter) {
      searchArr = filter.split(" ");
    }

    return (
      <div
        className={`${this.props.className} category-type-3`}
        onMouseOver={() => {
          this.onMouseOverHandler(true);
        }}
        onMouseOut={() => {
          this.onMouseOverHandler(false);
        }}
        onClick={(event) => {
          if (this.props.onClick) {
            this.props.onClick(this.props.linkDetails.get("rel"));
          }
          event.stopPropagation();
        }}
        ref={this.mainComponent}
      >
        <div className="row game">
          {game && (
            <div className="icon">
              {game.get("jackpotBalance") && (
                <div className="jackpot-amount">
                  {this.getTotalPool(this.state.jackpotPool, game, false)}
                </div>
              )}
              {this.state.isVisible && (
                <img
                  src={`${setDefaultImageFormat(
                    game
                      .getIn(["images", "iconUrl"])
                      .replace("width=90", "width=200") + "&theme=dark",
                    this.props.imageFormat.get("logoRound")
                  )}`}
                  className="d-none"
                  alt={game.get("name")}
                  onLoad={({ currentTarget }) => {
                    currentTarget.classList.remove("d-none");
                    this.iconDefaultRef.current.classList.add("d-none");
                  }}
                />
              )}
              <img
                ref={this.iconDefaultRef}
                src={bannerDefault}
                alt={game.get("name")}
              />
            </div>
          )}
          {!game && (
            <div className="icon">
              <img ref={this.iconDefaultRef} src={bannerDefault} alt="banner" />
            </div>
          )}
          <div className="col-8 details">
            <div className="h-100 d-flex align-items-center">
              <div>
                {filter ? (
                  <Fragment>
                    <div className="name">
                      <Highlighter
                        highlightClassName="matched-search"
                        searchWords={searchArr}
                        textToHighlight={game.get("name")}
                      />
                    </div>
                    <div className="provider">
                      <Highlighter
                        highlightClassName="matched-search"
                        searchWords={searchArr}
                        textToHighlight={game.get("provider")}
                      />
                    </div>
                    <div className="game-type">
                      <Highlighter
                        highlightClassName="matched-search"
                        searchWords={searchArr}
                        textToHighlight={game.get("gameType")}
                      />
                    </div>
                  </Fragment>
                ) : (
                  <Fragment>
                    <div className="name">
                      {game && game.get("name")}
                      {!game && <span className="dummy">XXXXXXXXXXX</span>}
                    </div>
                    <div className="provider">
                      {game && game.get("provider")}
                      {!game && <span className="dummy">XXXXXXXXXXX</span>}
                    </div>
                    <div className="game-type">
                      {game && game.get("gameType") ? (
                        game.get("gameType")
                      ) : (
                        <>&nbsp;</>
                      )}
                      {!game && <span className="dummy">XXXXXXXXXX</span>}
                    </div>
                  </Fragment>
                )}
              </div>
              <span className="game-feature-badge">
                {game && game.get("hasFreeRounds") && (
                  <span className="ribbonIcon">
                    <RibbonIcon color="rgba(255, 204, 0, 1)" selectedcolor="" />
                  </span>
                )}
                {game && game.get("partOfOnGoingTournament") && (
                  <span className="trophyIcon">
                    <TrophyIcon color="rgba(255, 204, 0, 1)" selectedcolor="" />
                  </span>
                )}
                {game && game.get("isJackpot") && (
                  <span className="jackpotIcon">
                    <CrownIcon color="rgba(255, 204, 0, 1)" />
                  </span>
                )}
                {game && game.get("isFeatured") && (
                  <span className="editorsChoiceIcon">
                    <EditorsChoiceIcon color="rgba(255, 204, 0, 1)" />
                  </span>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CategoryType3;
